/**
 * 대학 랜딩페이지(/university/:slug) 슬러그 ↔ 대학 코드 매핑.
 *
 * 포함 기준: 공개 매물이 1건 이상 있는 대학만 (2026-08-01 실측 26곳).
 * 매물 0건 대학(UOS·HUFS_GLOBAL·MYONGJI_YONGIN·CAU_ANSEONG)은 제외 —
 * 빈 랜딩은 도어웨이 페이지로 간주될 위험(경쟁감사: coliving 안티패턴).
 *
 * ⚠️ 이 집합은 엣지 og-injector 의 UNIVERSITY_SLUGS·sitemap-app.xml 과 반드시 일치해야 한다.
 * 셋의 동기화는 src/shared/lib/__test__/universitySlugs.sync.test.ts 가 강제한다.
 */
export const UNIVERSITY_LANDING_SLUGS: Record<string, string> = {
  'seoul-national-university': 'SNU',
  'chung-ang-university': 'CAU',
  'korea-university': 'KOREA',
  'sungkyunkwan-university': 'SKKU',
  'kyung-hee-university': 'KHU',
  'dongguk-university': 'DONGGUK',
  'soongsil-university': 'SSU',
  hufs: 'HUFS',
  'ewha-womans-university': 'EWHA',
  'konkuk-university': 'KONKUK',
  'hongik-university': 'HONGIK',
  'yonsei-university': 'YONSEI',
  'sogang-university': 'SOGANG',
  'hansung-university': 'HANSUNG',
  'sejong-university': 'SEJONG',
  'sungshin-womens-university': 'SUNGSHIN_WOMEN',
  'gachon-university': 'GACHON',
  'hanyang-university-erica': 'HANYANG_ERICA',
  'inha-university': 'INHA',
  'ajou-university': 'AJOU',
  'kyung-hee-university-global-campus': 'KHU_GLOBAL',
  'sungkyunkwan-university-suwon': 'SKKU_SUWON',
  'ansan-university': 'ANSAN',
  'bucheon-university': 'BUCHEON',
  'seoul-national-university-yeongeon': 'SNU_YEONGEON',
  'catholic-university-of-korea-bucheon': 'CATHOLIC_KOREA_BUCHEON',
};

// hasOwnProperty 가드: 'constructor' 같은 프로토타입 체인 키가 매칭되는 것을 차단 (리뷰 발견)
export const universityCodeFromSlug = (slug: string): string | undefined =>
  Object.prototype.hasOwnProperty.call(UNIVERSITY_LANDING_SLUGS, slug) ? UNIVERSITY_LANDING_SLUGS[slug] : undefined;
